import * as EquipmentService from '../services/equipment-service';

export function resetState(state) {
  return function (dispatch) {
    dispatch(reset(state));
  };
}

export function fetchEquipments() {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await EquipmentService.list();
      dispatch(success('FETCH_EQUIPMENTS', response.data));
    } catch(err) {
      dispatch(error('EQUIPMENT_ERROR', err));
    }
  };
}

export function save(equipment) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await EquipmentService.save(equipment);
      return dispatch(success('ADD_EQUIPMENT', response.data));
    } catch (err) {
      return dispatch(error('EQUIPMENT_ERROR', err));
    }
  };
}

export function update(equipment) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await EquipmentService.update(equipment);
      return dispatch(success('UPDATE_EQUIPMENT', response.data));
    } catch (err) {
      return dispatch(error('EQUIPMENT_ERROR', err));
    }
  };
}

/* Search Equipments */
export function search(searchParameters) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await EquipmentService.search(searchParameters);
      dispatch(success('SEARCH_EQUIPMENTS', response.data));
    } catch(err) {
      dispatch(error('EQUIPMENT_ERROR', err));
    }
  };
}

function reset(type) {
  return {
    type: type,
  };
}

function process() {
  return {
    type: 'PROCESSING_EQUIPMENT',
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}

function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}